import {COLOR_BLACK, COLOR_BLUE, COLOR_INPUT_BORDER, COLOR_RED, COLOR_WHITE} from '@/themes/colors.jsx';

const MuiInputThemeComponents = {
    components: {
        MuiFormControl: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    backgroundColor: COLOR_WHITE,
                    border: `1px solid ${COLOR_INPUT_BORDER}`,
                    borderRadius: 12,
                    padding: '0',

                    '&.xl': {
                        width: '450px',
                        maxWidth: '100%',
                    },

                    '&.md': {
                        width: '350px',
                        maxWidth: '100%',
                    },

                    '&.sm': {
                        width: '250px',
                        maxWidth: '100%',
                    },

                    '&.xsm': {
                        width: '170px',
                        maxWidth: '100%',
                    },

                    '&.xs': {
                        width: '150px',
                        maxWidth: '100%',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontFamily: '"ui-rounded", "Nunito", "Varela Round", system-ui, sans-serif',
                    padding: '0',
                    paddingTop: '6px',
                    paddingBottom: '6px',
                    color: COLOR_BLACK,
                    height: '100%',
                    fontSize: '17px',
                    lineHeight: '20px',

                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none !important',
                    },

                    '&.Mui-disabled': {
                        backgroundColor: '#fafafa',
                        borderRadius: '12px',
                    },
                },
                input: {
                    padding: '6px 5px 6px 24px',
                    height: '24px',
                    border: 'none !important',
                    backgroundColor: 'transparent',

                    '&:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0px 1000px #fff inset',
                    },

                    '&::placeholder': {
                        color: COLOR_BLACK,
                        opacity: '0.3',
                    },
                },
                multiline: {
                    minHeight: '175px',
                    alignItems: 'start',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontFamily: '"ui-rounded", "Nunito", "Varela Round", system-ui, sans-serif',
                    color: COLOR_BLACK,
                    backgroundColor: COLOR_WHITE,
                    fontSize: '13px',
                    fontWeight: 600,
                    padding: '0 6px',
                    maxWidth: 'calc(100% - 12px)',

                    [theme.breakpoints.down('md')]: {
                        maxWidth: '325px',
                    },

                    '&.Mui-focused': {
                        color: COLOR_BLACK,
                        zIndex: 1,
                    },

                    '&.Mui-error': {
                        color: COLOR_RED,
                    },
                }),
                shrink: {
                    transform: 'translate(18px, -8px) !important',
                    zIndex: 1,
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                positionEnd: {
                    marginRight: 24,
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    color: COLOR_BLUE,
                },
                colorSecondary: {
                    color: COLOR_INPUT_BORDER,
                },
            },
        },
    },
};

export default MuiInputThemeComponents;
